export default (theme) => {
  return theme.getLength;
};
